require('vue2-animate/dist/vue2-animate.min.css')
